import * as lef_slider from '../slider/slider.js';

export default () => {   
    lef_slider.generateSliders('.image-slider');
};